import English from "@/languages/en.json";
import French from "@/languages/fr.json";
import Italian from "@/languages/it.json";
import Spanish from "@/languages/es.json";
import Portuguese from "@/languages/pt.json";

export const LANGUAGES = [
  { code: "en-US", label: "English", messages: English },
  { code: "fr-FR", label: "Français", messages: French },
  { code: "it-IT", label: "Italiana", messages: Italian },
  { code: "es-ES", label: "Española", messages: Spanish },
  { code: "pt-PT", label: "Português", messages: Portuguese },
];
